import {MEDIA_TYPE, TrmzFile, TrmzMedium} from "@web-libs/features/files/trmz-file/domain/trmz-file.types";
import {TrmzFileDTO} from "@web-libs/features/files/trmz-file/api/trmz-file.types";
import {UrlConversionFunction} from "@web-libs/features/files/trmz-file/api/trmz-file-dto-converter";

export function parseTrmzFileTypeToMediaType(fileType: string): MEDIA_TYPE {
    if(fileType.startsWith('image')) {
        return 'image'
    } else if(fileType.startsWith('video')) {
        return 'video'
    } else {
        return 'unsupported'
    }
}

export  const parseDTOToFile = (dto: TrmzFileDTO, getUrl:UrlConversionFunction): TrmzFile => {
    return {
        id: dto.id,
        fileType: dto.fileType,
        fileName: dto.filename,
        fileUrl: getUrl(dto.id, dto.fileUploadType)
    }
}

export const parseDTOtoMedium = (dto: TrmzFileDTO, getUrl:UrlConversionFunction): TrmzMedium => {
    const trmzFile = parseDTOToFile(dto, getUrl)
    return {
        ...trmzFile,
        thumbnailUrl: getUrl(dto.id, dto.fileUploadType, 200),
        mediaType: parseTrmzFileTypeToMediaType(trmzFile.fileType)
    }
}
